import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "components/NoScrollDialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MDInput from "components/MDInput";
import LoadingButton from "components/LoadingButton";
import { Grid } from "@mui/material";
import TranslatableTextField from "components/TranslatableTextField";
import { useLanguage } from "contexts/language.context";

export default function SummaryGroupsEditNewDialog({
  isOpen,
  onSubmit,
  data,
  type,
}) {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [summaryGroup, setSummaryGroup] = React.useState({
    description: { en: "" },
  });
  const { label } = useLanguage();

  React.useEffect(() => {
    if (!isOpen) return;
    setOpen(true);
    setLoading(false);
    setSummaryGroup({
      description: { en: "" },
    });
  }, [isOpen]);

  React.useEffect(() => {
    setSummaryGroup({ ...data, description: data?.allLanguageDescription });
  }, [data]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={handleClose}
      PaperProps={{
        component: "form",
        onSubmit: async (event) => {
          event.preventDefault();

          setLoading(true);
          const result = await onSubmit(summaryGroup);
          if (result.success) {
            handleClose();
          }

          setLoading(false);
        },
      }}
    >
      <DialogTitle>
        {type == "edit"
          ? label("edit-summary-group")
          : label("create-summary-group")}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={1} sx={{ pt: 1.5 }}>
          <Grid item xs={12}>
            <TranslatableTextField
              autoFocus
              required
              id="description"
              name="description"
              label={label("name-singular")}
              type="text"
              values={summaryGroup.description}
              onChange={(e) => {
                setSummaryGroup({
                  ...summaryGroup,
                  description: e.target.value,
                });
              }}
              fullWidth
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{label("cancel-button")}</Button>
        <LoadingButton
          loading={loading}
          type="submit"
          variant="gradient"
          color="info"
        >
          {type == "edit" ? label("save-button") : label("create-button")}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
